import React from 'react';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';
import {
    NavigationItemOneStoryblok,
    NavigationItemTopStoryblok,
    NavigationItemTwoStoryblok,
    NavigationLinkStoryblok,
    TopNavigationStoryblok,
} from '../../../_shared/interfaces/storyblok';
import NavigationItem from './navigation-item';
import NavigationBanner from './navigation-banner';

import * as StylesHs from './navigation-menu-mobile.hs.module.scss';
import * as StylesDr from './navigation-menu-mobile.dr.module.scss';
import NavigationCustomer from './navigation-customer';
import { IAccountContext } from '../../../context/account/account.context';

const NavigationMenuMobile = ({
    blok,
    navigationItems,
    storyblokCommon,
    accountContext,
    onClose,
}: {
    blok: NavigationItemTopStoryblok | TopNavigationStoryblok | undefined;
    navigationItems?: (NavigationItemTopStoryblok | NavigationLinkStoryblok)[];
    storyblokCommon: StoryblokCommon;
    accountContext: IAccountContext;
    onClose?: () => any;
}) => {
    const styles = storyblokCommon.configuration.content.theme === 'dr' ? StylesDr : StylesHs;

    const [activeMobileNavigationItem, setActiveMobileNavigationItem] = React.useState<{
        navigationItemTop: NavigationItemTopStoryblok | TopNavigationStoryblok | undefined;
        navigationItemOne: NavigationItemOneStoryblok | undefined;
        navigationItemTwo: NavigationItemTwoStoryblok | undefined;
    }>({ navigationItemTop: blok, navigationItemOne: undefined, navigationItemTwo: undefined });

    React.useEffect(() => {
        if (!activeMobileNavigationItem.navigationItemTop && onClose) {
            onClose();
        }
    }, [activeMobileNavigationItem.navigationItemTop]);

    React.useEffect(() => {
        setActiveMobileNavigationItem({ ...activeMobileNavigationItem, navigationItemTop: blok });
    }, [blok]);

    return (
        <>
            {activeMobileNavigationItem.navigationItemTop && (
                <div className={styles.navigationMenuMobile} id={activeMobileNavigationItem.navigationItemTop._uid} role="none">
                    {activeMobileNavigationItem.navigationItemTop.component !== 'top_navigation' ? (
                        <>
                            <NavigationItem
                                blok={
                                    activeMobileNavigationItem.navigationItemTwo
                                        ? activeMobileNavigationItem.navigationItemTwo
                                        : activeMobileNavigationItem.navigationItemOne
                                        ? activeMobileNavigationItem.navigationItemOne
                                        : activeMobileNavigationItem.navigationItemTop
                                }
                                storyblokCommon={storyblokCommon}
                                onNavigationItemChange={(
                                    navigationItem: NavigationItemTopStoryblok | NavigationItemOneStoryblok | NavigationItemTwoStoryblok,
                                ) => {
                                    switch (navigationItem.component) {
                                        case 'navigation_item_top': {
                                            setActiveMobileNavigationItem({
                                                navigationItemTop:
                                                    navigationItem._uid === activeMobileNavigationItem.navigationItemTop?._uid
                                                        ? undefined
                                                        : navigationItem,
                                                navigationItemOne: undefined,
                                                navigationItemTwo: undefined,
                                            });
                                            break;
                                        }
                                        case 'navigation_item_one':
                                            setActiveMobileNavigationItem({
                                                navigationItemTop: activeMobileNavigationItem.navigationItemTop,
                                                navigationItemOne:
                                                    navigationItem._uid === activeMobileNavigationItem.navigationItemOne?._uid
                                                        ? undefined
                                                        : navigationItem,
                                                navigationItemTwo: undefined,
                                            });
                                            break;
                                        case 'navigation_item_two': {
                                            setActiveMobileNavigationItem({
                                                navigationItemTop: activeMobileNavigationItem.navigationItemTop,
                                                navigationItemOne: activeMobileNavigationItem.navigationItemOne,
                                                navigationItemTwo:
                                                    navigationItem._uid === activeMobileNavigationItem.navigationItemTwo?._uid
                                                        ? undefined
                                                        : navigationItem,
                                            });
                                            break;
                                        }
                                    }
                                }}
                            />

                            <NavigationBanner
                                blok={
                                    activeMobileNavigationItem.navigationItemTop?.navigation_banner &&
                                    activeMobileNavigationItem.navigationItemTop.navigation_banner[0]
                                }
                                storyblokCommon={storyblokCommon}
                            />
                        </>
                    ) : (
                        <NavigationCustomer
                            blok={activeMobileNavigationItem.navigationItemTop}
                            accountContext={accountContext}
                            storyblokCommon={storyblokCommon}
                        />
                    )}
                </div>
            )}
            {navigationItems &&
                navigationItems.map((item) => {
                    if (item.component === 'navigation_item_top') {
                        return (
                            <div key={item._uid + '-mobile-prender'}>
                                <div id={item._uid} className={styles.gridHidden} role="menu">
                                    <NavigationItem blok={item} storyblokCommon={storyblokCommon} showLinksOnly={true} />
                                </div>
                                {item.navigation_items.map((navigationItem) => {
                                    return (
                                        <div
                                            key={navigationItem._uid}
                                            id={'megamenu-mobile-' + navigationItem._uid}
                                            className={styles.gridHidden}
                                        >
                                            <NavigationItem key={item._uid} blok={navigationItem} storyblokCommon={storyblokCommon} />
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    }
                })}
        </>
    );
};

export default NavigationMenuMobile;
